import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import classnames from "classnames";
import { withStyles } from "@material-ui/styles";
import Cookies from "universal-cookie";

import Header from "../BillingHeader/BillingHeader";
import BillingSidebar from "../BillingSidebar/BillingSidebar";

// pages
import Corsi from "../../pages/billing/corsi";
import Impostazioni from "../../pages/billing/usersettings";
import EditCorso from "../../pages/billing/editCorso/EditCorso";
import EditStudente from "../../pages/billing/editStudente/EditStudente";
import Studenti from "../../pages/billing/studenti/Studenti";
import Ritirati from "../../pages/billing/ritirati/Ritirati";
import DaVerificare from "../../pages/billing/daVerificare/DaVerificare";
import InRitardo from "../../pages/billing/inRitardo/InRitardo";
import StudenteDetails from "../../pages/billing/studenteDetails/StudenteDetails";
import InsegnantiBilling from "../../pages/billing/insegnanti/Insegnanti";
import FattureInsegnante from "../../pages/billing/fattureInsegnante/FattureInsegnante";
import FattureInsegnanti from "../../pages/billing/fattureInsegnanti/FattureInsegnanti";
import Search from "../../pages/billing/billingSearch/Search";
import FattureInsegnantiShow from "../../pages/billing/fattureInsegnanti/FattureInsegnantiShow";
import FattureInsegnantiForfettario from "../../pages/billing/fattureInsegnanti/FattureInsegnantiForfettario";
import FattureInsegnantiAutonomi from "../../pages/billing/fattureInsegnanti/FattureInsegnantiAutonomi";
import ShowRestart from "../../pages/billing/fattureInsegnanti/ShowRestart";
import AutonomiOrdinario from "../../pages/billing/fattureInsegnanti/AutonomiOrdinario";
import AutonomiForfettario from "../../pages/billing/fattureInsegnanti/AutonomiForfettario";

const makeStyles = theme => ({
	root: {
		display: "flex",
		maxWidth: "100vw",
		overflowX: "hidden",
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		width: `calc(100vw - 240px)`,
		minHeight: "100vh",
	},
	contentShift: {
		width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	fakeToolbar: {
		...theme.mixins.toolbar,
	},
});

class BillingLayout extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			menuItems: [],
		};
	}

	async componentDidMount() {
		const cookies = new Cookies();
		const appId = cookies.get("appId", { path: "/" });
	}

	handleSearch(text) {
		this.setState({ searchParams: text });
		window.sessionStorage.setItem("search_text", text);
	}

	render() {
		// global
		const { classes } = this.props;

		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const userType = cookies.get("userType", { path: "/" });

		return (
			<div className={classes.root}>
				<>
					<Header history={this.props.history} onSearch={t => this.handleSearch(t)} />
					<BillingSidebar menuItems={this.state.menuItems} />
					<div
						className={classnames(classes.content, {
							[classes.contentShift]: null,
						})}
					>
						<div className={classes.fakeToolbar} />

						<Switch>
							<Route path="/billing/corsi" component={Corsi} />
							<Route path="/billing/usersettings" component={Impostazioni} />
							<Route path="/billing/editCorso" component={EditCorso} />
							<Route path="/billing/editStudente" component={EditStudente} />

							<Route path="/billing/studenti" component={Studenti} />
							<Route path="/billing/ritirati" component={Ritirati} />
							<Route path="/billing/studenteDetails" component={StudenteDetails} />

							<Route path="/billing/daVerificare" component={DaVerificare} />
							<Route path="/billing/inRitardo" component={InRitardo} />

							{/* <Route path="/billing/insegnanti" component={InsegnantiBilling} />
              <Route path="/billing/fattureInsegnante" component={FattureInsegnante} />
              <Route path="/billing/fattureInsegnanti" component={FattureInsegnanti} />
              <Route path="/billing/fattureShowRestart" component={ShowRestart} />
              <Route path="/billing/fattureForfettari" component={AutonomiForfettario} />
              <Route path="/billing/fattureOrdinari" component={AutonomiOrdinario} /> */}
							<Route path="/billing/search" component={Search} />

							<Route exact path="/billing/ui" render={() => <Redirect to="/billing/ui/icons" />} />
						</Switch>
					</div>
					<div className={classnames(classes.contentPhone)}></div>
				</>
			</div>
		);
	}
}

export default withStyles(makeStyles)(withRouter(BillingLayout));
